import { Button } from '../../../../components';
import { useAccountReport } from '../../hooks';
import DateRangePicker from '../DateRangePicker';
import Loading from '../Loading';

interface Props {
  isAdmin: boolean;
}

export default function AccountReportFilters({ isAdmin }: Props) {
  const {
    isLoading,
    startDate,
    endDate,
    onChangeShippedDates,
    clearFilters,
    onClickDownload,
  } = useAccountReport(isAdmin);

  return (
    <div className='d-flex flex-column gap-4'>
      {isLoading ? <Loading /> : ''}
      <DateRangePicker
        label='Created Date'
        startDate={startDate}
        endDate={endDate}
        onChangeDates={onChangeShippedDates}
        required
      />
      <div className='d-flex flex-column gap-2 align-items-center pt-4'>
        <Button
          text='Download'
          onClick={onClickDownload}
          disabled={isLoading}
        />
        <Button
          text='Cancel'
          onClick={clearFilters}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}
